import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export class UtilityButtonDefault extends React.Component {
  render() {
    return (
      <div className="utility-buttons">
        <p>
          <button type="button" className="btn btn-lg btn-default"
            onClick={this.props.onClick}
          >
            <FormattedMessage {...this.props.buttonName } />
          </button>
        </p>
      </div>
    );
  }
}

UtilityButtonDefault.propTypes = {
  buttonName: PropTypes.object,
  onClick: PropTypes.func,
};
